import { motion } from "framer-motion";

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="relative bg-[#0E0D0B] border-t border-white/[0.07] overflow-hidden"
    >
      <div className="px-6 md:px-12 pt-20 md:pt-28">
        <motion.h2
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1.1, ease: [0.16, 1, 0.3, 1] }}
          data-testid="footer-wordmark"
          className="font-serif-display font-light tracking-tighter leading-[0.85] text-[16vw] text-white/90 select-none"
        >
          Boardroom
        </motion.h2>
      </div>
      <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 px-6 md:px-12 py-8 mt-10 border-t border-white/10">
        <p className="font-mono-label text-[9px] tracking-[0.25em] uppercase text-white/40">
          © 2026 Boardroom. All decisions final.
        </p>
        <div className="flex gap-8">
          <a
            href="#top"
            data-testid="footer-back-top-link"
            className="font-mono-label text-[9px] tracking-[0.25em] uppercase text-white/40 hover:text-white transition-colors duration-300"
          >
            Back to top
          </a>
          <a
            href="/privacy"
            data-testid="footer-privacy-link"
            className="font-mono-label text-[9px] tracking-[0.25em] uppercase text-white/40 hover:text-white transition-colors duration-300"
          >
            Privacy
          </a>
        </div>
      </div>
    </footer>
  );
}
